import React, { useState } from 'react';
import { useI18n } from '~Hooks';

import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import { usePage } from '~Scenes/Handy/Context/PageProvider';
import { DeveloperKeypass } from '~Scenes/Handy/Scenes/Settings/General/DeveloperKeypass';
import OtherSettings from '~Scenes/Settings-v2/Scenes/Other';

/** Handheld shell around the shared Settings-v2 "Other" scene */
const General = () => {
  const page = usePage();
  const { i18n } = useI18n();

  const [showDeveloperKeypass, setShowDeveloperKeypass] = useState(false);

  const handleDeveloperPassSubmit = (value: string) => {
    if (value === '8888') {
      page.navigateTo('developer');
      setShowDeveloperKeypass(false);
    }
  };

  return (
    <HandyPageWrapper pageTitle={i18n('Handy.Settings.GeneralTitle')}>
      <DeveloperKeypass
        open={showDeveloperKeypass}
        onClose={() => setShowDeveloperKeypass(false)}
        onSubmit={handleDeveloperPassSubmit}
      />
      <OtherSettings
        isHandy
        // Developer tools are behind a keypass on handheld
        setSelectedPage={() => setShowDeveloperKeypass(true)}
        onOpenTerminal={() => page.navigateTo('managed-payments')}
      />
    </HandyPageWrapper>
  );
};

export default General;
